import React from 'react';
import HeaderItem from '../HeaderItem';
import { useVesselStore } from '../../../context/VesselContext';

const ContactComponent: React.FC = () => {
    const { selectedVessel } = useVesselStore();

    const mailto = 'mailto:bgodlbet@odfjell.com?subject=OrcaWeb on ' + selectedVessel?.vesselName;

    return (
        <a href={mailto}>
            <HeaderItem title={'Support'} iconName={'envelope'} path={''} />
        </a>
    );
};

export default ContactComponent;
